module.exports = __webpack_public_path__ + "static/media/Research Paper Search.cc305419.csv";